module.exports = __webpack_public_path__ + "img/icon-dance.4fdd9465.png";